const VERSION = "20.1.1";
export {
  VERSION
};
